import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import {
  GET_LIST_DISTINCT_QTY_POINT,
  GET_QTYPOINT,
  GET_QTY_POINT_DATA,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { createRef, useEffect, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { compact } from "lodash";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
//i18n
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

function QualityPointDailyDetail(props) {
  let history = useHistory();
  let { date, source } = useParams();

  const dispatch = useDispatch();

  const link = createRef();
  const permission = getPermission();
  const searchObj = { LOAD_DATE: date, QTYPOINT_SOURCE: source, QTYPOINT_NAME: "" };
  // const createObj = {};
  const [dataDetailBooking, setDataDetailBooking] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [listQualityPointDaily, setListQualityPointDaily] = useState([]);
  // const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();

  const [activeTab, setActiveTab] = useState("1");
  const [visibleModalConfirm, setVisibleModalConfirm] = useState(false);
  const [visibleUploadBooking, setVisibleUploadBooking] = useState(false);
  const [visibleSelectDate, setVisibleSelectDate] = useState(false);
  const [visibleDetailWeek, setVisibleDetailWeek] = useState(false);
  const [defaultDate, setDefaultDate] = useState(new Date());
  const [ModalConfirmMesHead, setModalConfirmMesHead] = useState(
    "มีข้อมูล Booking Data อยู่ในฐานข้อมูลของ TSO Dashboard อยู่แล้ว"
  );
  const [ModalConfirmMes, setModalConfirmMes] = useState(
    "คุณต้องการดำเนินการต่อหรือไม่"
  );

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  const [pageAdd, setPageAdd] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);

  const listData = [
    {
      Id: "1",
      Date: "25/09/2021",
      Shipper: "Capacity",
      ContactCode: " ",
      Area: "A1",
      Booking: "1,770,000",
    },
    {
      Id: "2",
      Date: "22/09/2021",
      Shipper: "EGAT",
      ContactCode: "2021-CSF-005",
      Area: "A1",
      Booking: "1,014,000",
    },
    {
      Id: "3",
      Date: "20/09/2021",
      Shipper: "EGAT",
      ContactCode: "2021-CSF-005",
      Area: "A2",
      Booking: "116,000",
    },
    {
      Id: "4",
      Date: "19/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "B",
      Booking: "128,350",
    },
    {
      Id: "5",
      Date: "18/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "C1",
      Booking: "127,620",
    },
    {
      Id: "6",
      Date: "17/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "C2",
      Booking: "302,510",
    },
    {
      Id: "7",
      Date: "17/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "D",
      Booking: "54,000",
    },
    {
      Id: "8",
      Date: "01/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "E",
      Booking: "116,000",
    },
    {
      Id: "9",
      Date: "01/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "Y",
      Booking: "1,128,050",
    },
  ];

  const gotoMainPage = () => {
    history.push("/quality-point-daily");
  };

  //sort Column//
  const defaultSorted = [
    {
      dataField: "QTYPOINT_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        <OverButton
          onClick={() => {
            setPageAdd(true);
          }}
          color="info"
          icon="fas fa-eye"
          label="View"
        />
        <OverButton
          onClick={() => {
            setPageAdd(true);
          }}
          color="info"
          icon="far fa-edit"
          label="Edit"
        />

        <OverButton
          onClick={() => {
            setModalDelete(true);
          }}
          color="danger"
          icon="fas fa-trash-alt"
          label="Delete"
        />
      </div>
    );
  };
  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "QTYPOINT_NAME",
      text: "GC Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "QTYPOINT_MASTER_NAME",
      text: "Quality Point",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
      // sort: true,
    },
    {
      dataField: "QTYPOINT_VALUE",
      text: "Value",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
      // sort: true,
    },
    {
      dataField: "CREATE_DATE",
      text: "Time Stamp",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "20%",
        fontSize: "12px",
      },
      style: {
        width: "20%",
        fontSize: "12px",
      },
      // sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.CREATE_DATE, "DD/MM/YYYY, HH:mm:ss"),
      // , HH:mm:ss
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    // resetModel();
    // setModelDeviceList(listData);

    ///fixed header table
    let tableId = "quality-point-daily-detail-table";
    let scrollY = 283;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  const downloadExcel = async () => {
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/downloadExcelQualityPointDailyFile?LOAD_DATE=" + moment(date).format("YYYY-MM-DD") + "&QTYPOINT_SOURCE=" + source, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      // fetch("https://tsoopwb.pttplc.com/api/DownloadFile/DownloadBookingFile?szFileName=" + pid , {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/vnd.ms-excel',
      //     'Authorization':"Bearer " + accessToken.access_token
      //   },
      // })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          'GC_Name_' + moment(date).format("DD-MM-YYYY") + '_Source_' + source + '.xlsx'
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    // getDataQualityPoint();
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  // const getDataQualityPoint = async (pidBooking) => {
  //   // setIsLoading(true);
  //   try {
  //     let res = await post(GET_BOOKING_CONF, pidBooking);
  //     console.log(res);
  //     setDataDetailBooking(res.data.bookConfList[0]);
  //   } catch (err) {
  //     toggleModalMessage(err.message);
  //   }
  //   // setIsLoading(false);
  // };

  const fetchData = async (searchData) => {
    // console.log(searchData);
    const objSearch = {
      ...(searchData.QTYPOINT_NAME != '') && { QTYPOINT_NAME: searchData.QTYPOINT_NAME },

      LOAD_DATE: searchData.LOAD_DATE, QTYPOINT_SOURCE: searchData.QTYPOINT_SOURCE
    }
    setIsLoading(true);
    try {
      let qualityPointMaster = await post(GET_QTYPOINT);

      // console.log(qualityPointMaster);

      let qualityPointDaily = await post(GET_QTY_POINT_DATA, objSearch);

      // console.log(qualityPointDaily);

      let qualityPointDailyList = qualityPointDaily.data.qtyPointDataList.map((obj) => {

        let qualityMasterName = qualityPointMaster.data.qtyPointList.find((item) => item.PID == obj.QTYPOINT_PID);

        return { ...obj, QTYPOINT_MASTER_NAME: qualityMasterName ? qualityMasterName.ALIAS_NAME : "", QTYPOINT_VALUE: numberFormat(obj.QTYPOINT_VALUE, 3) }
      });

      setModelDeviceList(qualityPointDailyList);
      // setModelDeviceList(res.data.qtyPointDataList);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}

                      {props.t("Quality Point Daily Detail ( GC Name )")}

                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Input Management
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/booking-data" style={{ color: "#556ee6" }}>
                            Quality Point Daily ( GC Name )
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Quality Point Daily Detail ( GC Name )
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div>
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Data Date : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{moment(date).format(
                      "DD/MM/YYYY"
                    )}</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Source : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{source}</span>
                  </div>
                  <hr />

                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-2 col-form-label d-flex align-items-center justify-content-end">
                          GC Name
                        </Label>
                        <Col sm={9}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search GC Name")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    QTYPOINT_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.QTYPOINT_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row">
                        <div className="d-flex align-items-center justify-content-start">
                          <Button color="info" className="mt-3" onClick={() => onSearch()}>
                            <i className="fas fa-search"></i>
                            &nbsp; Search
                          </Button>

                          <Button color="warning" className="mt-3 ms-2" onClick={() => resetSearch()}>
                            <i className="fas fa-redo-alt"></i>
                            &nbsp; Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mb-2 mt-3">
                    <Col sm="3">
                      <div className="d-grid gap-2 d-md-block">
                        {permission.eBKD && (
                          <Button
                            // onClick={() =>
                            //   setPageAdd(true)
                            // }
                            // className="btn-rounded"
                            color="success"
                            className="mt-2 mb-2"
                            onClick={() => downloadExcel()}
                          >
                            <i className="fas fa-file-download fa-lg"></i>
                            &nbsp; Download Excel
                          </Button>
                        )}
                      </div>
                    </Col>
                    <Col
                      sm="9"
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          onClick={() => gotoMainPage()}
                          // className="btn-rounded"
                          color="secondary"
                          className="mt-2 mb-2"
                        >
                          <i className="fas fa-angle-double-left"></i>
                          &nbsp; Back
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        <BootstrapTable
                          id="quality-point-daily-detail-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Loading show={isLoading} />

        {/* MessageDialog */}
        <MessageDialog
          isOpen={showMessage}
          hide={toggleModalMessage}
          title={titleMessageModal}
          message={bodyMessageModal}
        />

      </div>
    </React.Fragment>
  );
}

QualityPointDailyDetail.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ QualityPointDailyDetail }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(QualityPointDailyDetail));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
